import { ReactNode, useMemo } from 'react';
import AgoraRTC, { AgoraRTCProvider } from 'agora-rtc-react';
import { isMobileDevice } from '@/lib/utils';

enum AgoraLogLevel {
  DEBUG,
  INFO,
  WARNING,
  ERROR,
  NONE,
}
AgoraRTC.setLogLevel(
  import.meta.env.DEV ? AgoraLogLevel.DEBUG : AgoraLogLevel.WARNING,
);

export default function withAgoraClient<T extends object>(
  Component: (props: T) => ReactNode,
) {
  return function ConnectedComponent(props: T) {
    const agoraClient = useMemo(() => {
      const isMobile = isMobileDevice();
      
      return AgoraRTC.createClient({
        // Use H.264 on mobile for better hardware acceleration support
        codec: isMobile ? 'h264' : 'vp8',
        mode: 'rtc',
        role: 'host',
      });
    }, []);

    return (
      <AgoraRTCProvider client={agoraClient}>
        <Component {...props} />
      </AgoraRTCProvider>
    )
  };
}
